import {
    PhrasesSelectorGroupInfo,
    PhrasesSelectorStartPhraseNode,
    PhrasesSelectorStartPhrases,
    PhrasesSelectorWizardId
} from '../../typings/phrases';

import { PhrasesSelectorAddKeywordsAction } from './persistentData';
import { PhrasesSelectorRefinementsAction } from './refinements';

interface PhrasesSelectorBaseAction {
    wizardId: PhrasesSelectorWizardId;
}

export const PHRASES_SELECTOR_GET_STATS = 'PHRASES_SELECTOR_GET_STATS';
export type PHRASES_SELECTOR_GET_STATS = typeof PHRASES_SELECTOR_GET_STATS;

export interface PhrasesSelectorGetStatsAction extends PhrasesSelectorBaseAction {
    type: PHRASES_SELECTOR_GET_STATS;
    phrases: Array<string>;
}

export function phrasesSelectorGetStats(
    wizardId: PhrasesSelectorWizardId,
    phrases: Array<string>
): PhrasesSelectorGetStatsAction {
    return {
        type: PHRASES_SELECTOR_GET_STATS,
        wizardId,
        phrases
    };
}

export const PHRASES_SELECTOR_PHRASE_STATS_FETCH = 'PHRASES_SELECTOR_PHRASE_STATS_FETCH';
export type PHRASES_SELECTOR_PHRASE_STATS_FETCH = typeof PHRASES_SELECTOR_PHRASE_STATS_FETCH;

export interface PhrasesSelectorPhraseStatsFetchAction extends PhrasesSelectorBaseAction {
    type: PHRASES_SELECTOR_PHRASE_STATS_FETCH;
    phrase: PhrasesSelectorStartPhraseNode;
}

export function phrasesSelectorPhraseStatsFetch(
    wizardId: PhrasesSelectorWizardId,
    phrase: PhrasesSelectorStartPhraseNode
): PhrasesSelectorPhraseStatsFetchAction {
    return {
        type: PHRASES_SELECTOR_PHRASE_STATS_FETCH,
        wizardId,
        phrase
    };
}

export const PHRASES_SELECTOR_OPEN_EDITOR = 'PHRASES_SELECTOR_OPEN_EDITOR';
export type PHRASES_SELECTOR_OPEN_EDITOR = typeof PHRASES_SELECTOR_OPEN_EDITOR;

export interface PhrasesSelectorOpenEditorAction extends PhrasesSelectorBaseAction {
    type: PHRASES_SELECTOR_OPEN_EDITOR;
    groupInfo: PhrasesSelectorGroupInfo;
}

export function phrasesSelectorOpenEditor(
    wizardId: PhrasesSelectorWizardId,
    groupInfo: PhrasesSelectorGroupInfo
): PhrasesSelectorOpenEditorAction {
    return {
        type: PHRASES_SELECTOR_OPEN_EDITOR,
        wizardId,
        groupInfo
    };
}

export const PHRASES_SELECTOR_SHOW_EDITOR = 'PHRASES_SELECTOR_SHOW_EDITOR';
export type PHRASES_SELECTOR_SHOW_EDITOR = typeof PHRASES_SELECTOR_SHOW_EDITOR;

export interface PhrasesSelectorShowEditorAction extends PhrasesSelectorBaseAction {
    type: PHRASES_SELECTOR_SHOW_EDITOR;
}

export function phrasesSelectorShowEditor(wizardId: PhrasesSelectorWizardId): PhrasesSelectorShowEditorAction {
    return {
        type: PHRASES_SELECTOR_SHOW_EDITOR,
        wizardId
    };
}

export const PHRASES_SELECTOR_HIDE_EDITOR = 'PHRASES_SELECTOR_HIDE_EDITOR';
export type PHRASES_SELECTOR_HIDE_EDITOR = typeof PHRASES_SELECTOR_HIDE_EDITOR;

export interface PhrasesSelectorHideEditorAction extends PhrasesSelectorBaseAction {
    type: PHRASES_SELECTOR_HIDE_EDITOR;
}

export function phrasesSelectorHideEditor(wizardId: PhrasesSelectorWizardId): PhrasesSelectorHideEditorAction {
    return {
        type: PHRASES_SELECTOR_HIDE_EDITOR,
        wizardId
    };
}

export const PHRASES_SELECTOR_CLOSE_EDITOR = 'PHRASES_SELECTOR_CLOSE_EDITOR';
export type PHRASES_SELECTOR_CLOSE_EDITOR = typeof PHRASES_SELECTOR_CLOSE_EDITOR;

export interface PhrasesSelectorCloseEditorAction extends PhrasesSelectorBaseAction {
    type: PHRASES_SELECTOR_CLOSE_EDITOR;
}

export function phrasesSelectorCloseEditor(wizardId: PhrasesSelectorWizardId): PhrasesSelectorCloseEditorAction {
    return {
        type: PHRASES_SELECTOR_CLOSE_EDITOR,
        wizardId
    };
}

export const PHRASES_SELECTOR_GET_KEYWORDS = 'PHRASES_SELECTOR_GET_KEYWORDS';
export type PHRASES_SELECTOR_GET_KEYWORDS = typeof PHRASES_SELECTOR_GET_KEYWORDS;

export interface PhrasesSelectorGetKeywordsAction extends PhrasesSelectorBaseAction {
    type: PHRASES_SELECTOR_GET_KEYWORDS;
    campaignId: string;
    groupId: string;
}

export function phrasesSelectorGetKeywords(
    wizardId: PhrasesSelectorWizardId,
    campaignId: string,
    groupId: string
): PhrasesSelectorGetKeywordsAction {
    return {
        type: PHRASES_SELECTOR_GET_KEYWORDS,
        wizardId,
        campaignId,
        groupId
    };
}

export const PHRASES_SELECTOR_SAVE_PHRASES = 'PHRASES_SELECTOR_SAVE_PHRASES';
export type PHRASES_SELECTOR_SAVE_PHRASES = typeof PHRASES_SELECTOR_SAVE_PHRASES;

export interface PhrasesSelectorSavePhrasesAction extends PhrasesSelectorBaseAction {
    type: PHRASES_SELECTOR_SAVE_PHRASES;
}

export function phrasesSelectorSavePhrases(wizardId: PhrasesSelectorWizardId): PhrasesSelectorSavePhrasesAction {
    return {
        type: PHRASES_SELECTOR_SAVE_PHRASES,
        wizardId
    };
}

export const PHRASES_SELECTOR_SAVE_PHRASES_ERROR = 'PHRASES_SELECTOR_SAVE_PHRASES_ERROR';
export type PHRASES_SELECTOR_SAVE_PHRASES_ERROR = typeof PHRASES_SELECTOR_SAVE_PHRASES_ERROR;

export interface PhrasesSelectorSavePhrasesErrorAction extends PhrasesSelectorBaseAction {
    type: PHRASES_SELECTOR_SAVE_PHRASES_ERROR;
}

export function phrasesSelectorSavePhrasesError(
    wizardId: PhrasesSelectorWizardId
): PhrasesSelectorSavePhrasesErrorAction {
    return {
        type: PHRASES_SELECTOR_SAVE_PHRASES_ERROR,
        wizardId
    };
}

export const PHRASES_SELECTOR_MANUAL_VALUE_SUBMIT = 'PHRASES_SELECTOR_MANUAL_VALUE_SUBMIT';
export type PHRASES_SELECTOR_MANUAL_VALUE_SUBMIT = typeof PHRASES_SELECTOR_MANUAL_VALUE_SUBMIT;

export interface PhrasesSelectorManualValueSubmitAction extends PhrasesSelectorBaseAction {
    type: PHRASES_SELECTOR_MANUAL_VALUE_SUBMIT;
}

export function phrasesSelectorManualValueSubmit(
    wizardId: PhrasesSelectorWizardId
): PhrasesSelectorManualValueSubmitAction {
    return {
        type: PHRASES_SELECTOR_MANUAL_VALUE_SUBMIT,
        wizardId
    };
}

export const PHRASES_SELECTOR_SET_START_PHRASES_ERROR = 'PHRASES_SELECTOR_SET_START_PHRASES_ERROR';
export type PHRASES_SELECTOR_SET_START_PHRASES_ERROR = typeof PHRASES_SELECTOR_SET_START_PHRASES_ERROR;

export interface PhrasesSelectorSetStartPhrasesErrorAction extends PhrasesSelectorBaseAction {
    type: PHRASES_SELECTOR_SET_START_PHRASES_ERROR;
    message: string;
}

export function phrasesSelectorSetStartPhrasesError(
    wizardId: PhrasesSelectorWizardId,
    message: string
): PhrasesSelectorSetStartPhrasesErrorAction {
    return {
        type: PHRASES_SELECTOR_SET_START_PHRASES_ERROR,
        wizardId,
        message
    };
}

export const PHRASES_SELECTOR_RESET_STATUS = 'PHRASES_SELECTOR_RESET_STATUS';
export type PHRASES_SELECTOR_RESET_STATUS = typeof PHRASES_SELECTOR_RESET_STATUS;

export interface PhrasesSelectorResetStatusAction extends PhrasesSelectorBaseAction {
    type: PHRASES_SELECTOR_RESET_STATUS;
}

export function phrasesSelectorResetStatus(wizardId: PhrasesSelectorWizardId): PhrasesSelectorResetStatusAction {
    return {
        type: PHRASES_SELECTOR_RESET_STATUS,
        wizardId
    };
}

export const PHRASES_SELECTOR_MINUS_WORD_ADD_METRICA = 'PHRASES_SELECTOR_MINUS_WORD_ADD_METRICA';
export type PHRASES_SELECTOR_MINUS_WORD_ADD_METRICA = typeof PHRASES_SELECTOR_MINUS_WORD_ADD_METRICA;

export interface PhrasesSelectorMinusWordAddMetricaAction extends PhrasesSelectorBaseAction {
    type: PHRASES_SELECTOR_MINUS_WORD_ADD_METRICA;
}

export function phrasesSelectorMinusWordAddMetrica(
    wizardId: PhrasesSelectorWizardId
): PhrasesSelectorMinusWordAddMetricaAction {
    return {
        type: PHRASES_SELECTOR_MINUS_WORD_ADD_METRICA,
        wizardId
    };
}

export const PHRASES_SELECTOR_MINUS_PHRASE_ADD_METRICA = 'PHRASES_SELECTOR_MINUS_PHRASE_ADD_METRICA';
export type PHRASES_SELECTOR_MINUS_PHRASE_ADD_METRICA = typeof PHRASES_SELECTOR_MINUS_PHRASE_ADD_METRICA;

export interface PhrasesSelectorMinusPhraseAddMetricaAction extends PhrasesSelectorBaseAction {
    type: PHRASES_SELECTOR_MINUS_PHRASE_ADD_METRICA;
}

export function phrasesSelectorMinusPhraseAddMetrica(
    wizardId: PhrasesSelectorWizardId
): PhrasesSelectorMinusPhraseAddMetricaAction {
    return {
        type: PHRASES_SELECTOR_MINUS_PHRASE_ADD_METRICA,
        wizardId
    };
}

export const PHRASES_SELECTOR_MANUAL_MINUS_PHRASE_ADD_METRICA = 'PHRASES_SELECTOR_MANUAL_MINUS_PHRASE_ADD_METRICA';
export type PHRASES_SELECTOR_MANUAL_MINUS_PHRASE_ADD_METRICA = typeof PHRASES_SELECTOR_MANUAL_MINUS_PHRASE_ADD_METRICA;

export interface PhrasesSelectorManualMinusPhraseAddMetricaAction extends PhrasesSelectorBaseAction {
    type: PHRASES_SELECTOR_MANUAL_MINUS_PHRASE_ADD_METRICA;
}

export function phrasesSelectorManualMinusPhraseAddMetrica(
    wizardId: PhrasesSelectorWizardId
): PhrasesSelectorManualMinusPhraseAddMetricaAction {
    return {
        type: PHRASES_SELECTOR_MANUAL_MINUS_PHRASE_ADD_METRICA,
        wizardId
    };
}

export const PHRASES_SELECTOR_KEYWORD_ADD_METRICA = 'PHRASES_SELECTOR_KEYWORD_ADD_METRICA';
export type PHRASES_SELECTOR_KEYWORD_ADD_METRICA = typeof PHRASES_SELECTOR_KEYWORD_ADD_METRICA;

export interface PhrasesSelectorKeywordAddMetricaAction extends PhrasesSelectorBaseAction {
    type: PHRASES_SELECTOR_KEYWORD_ADD_METRICA;
}

export function phrasesSelectorKeywordAddMetrica(
    wizardId: PhrasesSelectorWizardId
): PhrasesSelectorKeywordAddMetricaAction {
    return {
        type: PHRASES_SELECTOR_KEYWORD_ADD_METRICA,
        wizardId
    };
}

export const PHRASES_SELECTOR_BULK_KEYWORDS_ADD_METRICA = 'PHRASES_SELECTOR_BULK_KEYWORDS_ADD_METRICA';
export type PHRASES_SELECTOR_BULK_KEYWORDS_ADD_METRICA = typeof PHRASES_SELECTOR_BULK_KEYWORDS_ADD_METRICA;

export interface PhrasesSelectorBulkKeywordsAddMetricaAction extends PhrasesSelectorBaseAction {
    type: PHRASES_SELECTOR_BULK_KEYWORDS_ADD_METRICA;
}

export function phrasesSelectorBulkKeywordsAddMetrica(
    wizardId: PhrasesSelectorWizardId
): PhrasesSelectorBulkKeywordsAddMetricaAction {
    return {
        type: PHRASES_SELECTOR_BULK_KEYWORDS_ADD_METRICA,
        wizardId
    };
}

export const PHRASES_SELECTOR_REFINE_POPUP_OPEN_METRICA = 'PHRASES_SELECTOR_REFINE_POPUP_OPEN_METRICA';
export type PHRASES_SELECTOR_REFINE_POPUP_OPEN_METRICA = typeof PHRASES_SELECTOR_REFINE_POPUP_OPEN_METRICA;

export interface PhrasesSelectorRefinePopupOpenMetricaAction extends PhrasesSelectorBaseAction {
    type: PHRASES_SELECTOR_REFINE_POPUP_OPEN_METRICA;
}

export function phrasesSelectorRefinePopupOpenMetrica(
    wizardId: PhrasesSelectorWizardId
): PhrasesSelectorRefinePopupOpenMetricaAction {
    return {
        type: PHRASES_SELECTOR_REFINE_POPUP_OPEN_METRICA,
        wizardId
    };
}

export const PHRASES_SELECTOR_SET_GROUP_INFO = 'PHRASES_SELECTOR_SET_GROUP_INFO';
export type PHRASES_SELECTOR_SET_GROUP_INFO = typeof PHRASES_SELECTOR_SET_GROUP_INFO;

export interface PhrasesSelectorSetGroupInfoAction extends PhrasesSelectorBaseAction {
    type: PHRASES_SELECTOR_SET_GROUP_INFO;
    groupInfo: PhrasesSelectorGroupInfo;
}

export function phrasesSelectorSetGroupInfo(
    wizardId: PhrasesSelectorWizardId,
    groupInfo: PhrasesSelectorGroupInfo
): PhrasesSelectorSetGroupInfoAction {
    return {
        type: PHRASES_SELECTOR_SET_GROUP_INFO,
        wizardId,
        groupInfo
    };
}

export const PHRASES_SELECTOR_SET_LOADING_FALSE = 'PHRASES_SELECTOR_SET_LOADING_FALSE';
export type PHRASES_SELECTOR_SET_LOADING_FALSE = typeof PHRASES_SELECTOR_SET_LOADING_FALSE;

export interface PhrasesSelectorSetLoadingFalseAction extends PhrasesSelectorBaseAction {
    type: PHRASES_SELECTOR_SET_LOADING_FALSE;
}

export function phrasesSelectorSetLoadingFalse(
    wizardId: PhrasesSelectorWizardId
): PhrasesSelectorSetLoadingFalseAction {
    return {
        type: PHRASES_SELECTOR_SET_LOADING_FALSE,
        wizardId
    };
}

export const PHRASES_SELECTOR_SET_START_PHRASES = 'PHRASES_SELECTOR_SET_START_PHRASES';
export type PHRASES_SELECTOR_SET_START_PHRASES = typeof PHRASES_SELECTOR_SET_START_PHRASES;

export interface PhrasesSelectorSetStartPhrasesAction extends PhrasesSelectorBaseAction {
    type: PHRASES_SELECTOR_SET_START_PHRASES;
    phrases: PhrasesSelectorStartPhrases;
}

export function phrasesSelectorSetStartPhrases(
    wizardId: PhrasesSelectorWizardId,
    phrases: PhrasesSelectorStartPhrases
): PhrasesSelectorSetStartPhrasesAction {
    return {
        type: PHRASES_SELECTOR_SET_START_PHRASES,
        wizardId,
        phrases
    };
}

export const PHRASES_SELECTOR_UPDATE_START_PHRASES = 'PHRASES_SELECTOR_UPDATE_START_PHRASES';
export type PHRASES_SELECTOR_UPDATE_START_PHRASES = typeof PHRASES_SELECTOR_UPDATE_START_PHRASES;

export interface PhrasesSelectorUpdateStartPhrasesAction extends PhrasesSelectorBaseAction {
    type: PHRASES_SELECTOR_UPDATE_START_PHRASES;
    phrases: Array<PhrasesSelectorStartPhraseNode>;
}

export function phrasesSelectorUpdateStartPhrases(
    wizardId: PhrasesSelectorWizardId,
    phrases: Array<PhrasesSelectorStartPhraseNode>
): PhrasesSelectorUpdateStartPhrasesAction {
    return {
        type: PHRASES_SELECTOR_UPDATE_START_PHRASES,
        wizardId,
        phrases
    };
}

export const PHRASES_SELECTOR_SET_GROUP_KEYWORDS = 'PHRASES_SELECTOR_SET_GROUP_KEYWORDS';
export type PHRASES_SELECTOR_SET_GROUP_KEYWORDS = typeof PHRASES_SELECTOR_SET_GROUP_KEYWORDS;

export interface PhrasesSelectorSetGroupKeywordsAction extends PhrasesSelectorBaseAction {
    type: PHRASES_SELECTOR_SET_GROUP_KEYWORDS;
    keywords: Array<string>;
}

export function phrasesSelectorSetGroupKeywords(
    wizardId: PhrasesSelectorWizardId,
    keywords: Array<string>
): PhrasesSelectorSetGroupKeywordsAction {
    return {
        type: PHRASES_SELECTOR_SET_GROUP_KEYWORDS,
        wizardId,
        keywords
    };
}

export const PHRASES_SELECTOR_START_PHRASES_CLEAR_METRICA = 'PHRASES_SELECTOR_START_PHRASES_CLEAR_METRICA';
export type PHRASES_SELECTOR_START_PHRASES_CLEAR_METRICA = typeof PHRASES_SELECTOR_START_PHRASES_CLEAR_METRICA;

export interface PhrasesSelectorStartPhrasesClearMetricaAction extends PhrasesSelectorBaseAction {
    type: PHRASES_SELECTOR_START_PHRASES_CLEAR_METRICA;
}

export function phrasesSelectorStartPhrasesClearMetrica(
    wizardId: PhrasesSelectorWizardId
): PhrasesSelectorStartPhrasesClearMetricaAction {
    return {
        wizardId,
        type: PHRASES_SELECTOR_START_PHRASES_CLEAR_METRICA
    };
}

export type PhrasesSelectorAction =
    | PhrasesSelectorGetStatsAction
    | PhrasesSelectorRefinementsAction
    | PhrasesSelectorPhraseStatsFetchAction
    | PhrasesSelectorOpenEditorAction
    | PhrasesSelectorShowEditorAction
    | PhrasesSelectorHideEditorAction
    | PhrasesSelectorCloseEditorAction
    | PhrasesSelectorAddKeywordsAction
    | PhrasesSelectorSetStartPhrasesAction
    | PhrasesSelectorUpdateStartPhrasesAction
    | PhrasesSelectorGetKeywordsAction
    | PhrasesSelectorSavePhrasesAction
    | PhrasesSelectorSavePhrasesErrorAction
    | PhrasesSelectorManualValueSubmitAction
    | PhrasesSelectorSetStartPhrasesErrorAction
    | PhrasesSelectorResetStatusAction
    | PhrasesSelectorMinusWordAddMetricaAction
    | PhrasesSelectorMinusPhraseAddMetricaAction
    | PhrasesSelectorManualMinusPhraseAddMetricaAction
    | PhrasesSelectorBulkKeywordsAddMetricaAction
    | PhrasesSelectorKeywordAddMetricaAction
    | PhrasesSelectorRefinePopupOpenMetricaAction
    | PhrasesSelectorSetGroupInfoAction
    | PhrasesSelectorSetLoadingFalseAction
    | PhrasesSelectorSetGroupKeywordsAction
    | PhrasesSelectorStartPhrasesClearMetricaAction;
